import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { OperateDeviceComponent } from './operate-device/operate-device.component';
import { SelectPropertyComponent } from './select-property/select-property.component';
import { RequestAccessComponent } from './request-access/request-access.component';
import { ManageNumbersComponent } from './manage-numbers/manage-numbers.component';
import { AvailablePropertiesComponent } from './available-properties/available-properties.component';
import { AccessManagementComponent } from './access-management/access-management.component';
import { AccessLogComponent } from './access-log/access-log.component';
import { UserProfilesComponent } from './user-profiles/user-profiles.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { ForgetUsernameComponent } from './forget-username/forget-username.component';
import { QuickAccessComponent } from './quick-access/quick-access.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthGuard } from './_helpers';
import { Role } from './_models/role';
import { VisitorComponent } from './visitor/visitor.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { ManageGuestComponent } from './manage-guest/manage-guest.component';
import { GuestAccessComponent } from './guest-access/guest-access.component';
import { KioskAccessComponent } from './kiosk-access/kiosk-access.component';
import { NoticesComponent } from './notices/notices.component';
import { ManageNoticesComponent } from './manage-notices/manage-notices.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'registration', component: RegistrationComponent},
    { path: 'forget-password', component: ForgetPasswordComponent},
    { path: 'operate-device/:propertyid', component: OperateDeviceComponent, canActivate: [AuthGuard]},
    { path: 'property', component: SelectPropertyComponent, canActivate: [AuthGuard] },
    { path: 'device', component: OperateDeviceComponent, canActivate: [AuthGuard]},
    { path: 'request-access', component: RequestAccessComponent, canActivate: [AuthGuard]},
    {
        path: 'delete-account/:action',
        component: DeleteAccountComponent
    },
    {
        path: 'delete-account',
        component: DeleteAccountComponent
    },
    {
        path: 'manage-numbers/:action/:propertyid',
        component: ManageNumbersComponent,
        canActivate: [AuthGuard],
        data: {roles: [Role.ROLE_ADMIN]}
    },
    {
        path: 'available-properties/:action',
        component: AvailablePropertiesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'access-management/:propertyid',
        component: AccessManagementComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.ROLE_ADMIN, Role.ROLE_SUPER]}
    },
    {
        path: 'access-log/:propertyid',
        component: AccessLogComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.ROLE_ADMIN]}
    },
    {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.ROLE_SUPER]}
    },
    {
        path: 'user-profiles',
        component: UserProfilesComponent,
        canActivate: [AuthGuard],
        data: {roles: [Role.ROLE_SUPER]}
    },
    {
        path: 'user-roles/:action',
        component: UserRolesComponent,
        canActivate: [AuthGuard],
        data: {roles: [Role.ROLE_SUPER]}
    },
    {
        path: 'forget-username',
        component: ForgetUsernameComponent
    },
    {
        path: 'visitor',
        component: VisitorComponent
    },
    {
        path: 'visitor/:action',
        component: VisitorComponent
    },
    {
        path: 'manage-guest',
        component: ManageGuestComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.ROLE_ADMIN, Role.ROLE_SUPER] }
    },
    {
        path: 'guest-access',
        component: GuestAccessComponent
    },
    {
        path: 'kiosk-access',
        component: KioskAccessComponent
    },
    {
        path: 'notices/:propertyid',
        component: NoticesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'manage-notices',
        component: ManageNoticesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.ROLE_ADMIN] }
    },
    {
        path: 'manage-numbers/:action',
        component: ManageNumbersComponent,
        canActivate: [AuthGuard],
        data: {roles: [Role.ROLE_ADMIN]}
    },
    {
        path: 'quick-access/:action',
        component: QuickAccessComponent,
    },
    {
        path: 'quick-access/:action/:id',
        component: QuickAccessComponent
    },
    { path: 'change-password/:token', component: ChangePasswordComponent},
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
